/*
 * CO-CRIE CONOSCO — formulário da página (sections/co-crie-page.liquid).
 * Mesmo envio do pop-up (assets/co-crie-popup.js): POST multipart para o webhook do n8n, que faz a validação de
 * verdade. Aqui só a pré-checagem amigável (campos, tipo e tamanho da imagem) e a troca formulário → agradecimento.
 */
(function () {
  'use strict';

  var SENT_KEY = 'ls:cocrie:enviado';
  var MAX_BYTES = 5 * 1024 * 1024;
  var TIPOS = ['image/jpeg', 'image/png', 'image/webp'];

  function init(root) {
    if (root.hasAttribute('data-cocrie-ready')) return;
    root.setAttribute('data-cocrie-ready', '');

    var form = root.querySelector('[data-cocrie-form]');
    var done = root.querySelector('[data-cocrie-done]');
    var err = root.querySelector('[data-cocrie-error]');
    var count = root.querySelector('[data-cocrie-count]');
    var submit = root.querySelector('[data-cocrie-submit]');
    var openedAt = Date.now();

    function showError(msg) { err.textContent = msg; err.hidden = !msg; }

    var desc = form.querySelector('textarea[name="descricao"]');
    desc.addEventListener('input', function () { count.textContent = desc.value.length + '/2000'; });

    var fileInput = form.querySelector('input[name="arquivo"]');
    var upload = form.querySelector('[data-cocrie-upload]');
    var preview = upload.querySelector('.cocrie-pg__upload-preview');
    var removeBtn = form.querySelector('[data-cocrie-remove]');
    var previewUrl = null;
    function clearFile() {
      fileInput.value = '';
      if (previewUrl) { URL.revokeObjectURL(previewUrl); previewUrl = null; }
      preview.hidden = true; preview.removeAttribute('src');
      upload.classList.remove('has-file'); removeBtn.hidden = true;
    }
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return clearFile();
      if (TIPOS.indexOf(f.type) === -1) { clearFile(); return showError('Envie uma imagem JPG, PNG ou WEBP.'); }
      if (f.size > MAX_BYTES) { clearFile(); return showError('A imagem passou de 5 MB. Escolha uma menor.'); }
      showError('');
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      previewUrl = URL.createObjectURL(f);
      preview.src = previewUrl; preview.hidden = false;
      upload.classList.add('has-file'); removeBtn.hidden = false;
    });
    removeBtn.addEventListener('click', clearFile);

    root.querySelector('[data-cocrie-again]').addEventListener('click', function () {
      done.hidden = true; form.hidden = false; openedAt = Date.now();
      form.querySelector('#cocrie-pg-titulo').focus();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError('');
      form.querySelectorAll('.is-invalid').forEach(function (el) { el.classList.remove('is-invalid'); });

      var invalid = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (el) { return !el.checkValidity(); });
      if (invalid.length) {
        invalid.forEach(function (el) { el.classList.add('is-invalid'); });
        invalid[0].focus();
        return showError('Preencha os campos destacados.');
      }

      var data = new FormData(form);
      var file = data.get('arquivo');
      if (file && typeof file === 'object' && !file.size) data.delete('arquivo');
      data.append('t', String(Date.now() - openedAt));
      data.append('pagina', window.location.pathname.slice(0, 200));

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      var label = submit.textContent;
      submit.textContent = 'Enviando…';

      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 30000) : null;

      fetch(root.getAttribute('data-endpoint'), { method: 'POST', body: data, signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          if (res && res.ok) {
            try { window.localStorage.setItem(SENT_KEY, 'true'); } catch (x) { /* noop */ }
            form.reset();
            clearFile();
            count.textContent = '0/2000';
            form.hidden = true; done.hidden = false;
            done.focus();
            done.scrollIntoView({ block: 'center', behavior: 'smooth' });
          } else {
            showError((res && res.motivo) || 'Não foi possível enviar agora. Tente de novo em instantes.');
          }
        })
        .catch(function () { showError('Não foi possível enviar agora. Confira sua conexão e tente de novo.'); })
        .finally(function () {
          if (timer) clearTimeout(timer);
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          submit.textContent = label;
        });
    });
  }

  function boot() { document.querySelectorAll('[data-cocrie-page]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
